import type { CoverSheetConfigCard } from '../../types';
import { licenseNumberCharacterValidation } from '../validation';

export const counterpartyAgentCard = {
  id: 'counterpartyAgent',
  innerTitle: "Counterparty's Agent x",
  outerTitle: "Counterparty's Agents",
  isAddable: true,
  addText: "Co-Counterparty's Agent",
  addableTitle: "Co-Counterparty's Agent",
  maxAddable: 2,
  addByDefault: true,
  entity: 'contacts',
  entityType: 'counterpartyAgent',
  isCollapsible: true,
  syncsWithGoogleContacts: true,
  displayFields: [
    {
      name: 'contacts.counterpartyAgent.x.firstName',
      type: 'name',
    },
    {
      name: 'contacts.counterpartyAgent.x.lastName',
      type: 'name',
    },
    {
      name: 'contacts.counterpartyAgent.x.licenseNumber',
      type: 'default',
    },
    {
      name: 'contacts.counterpartyAgent.x.email',
      type: 'email',
    },
    {
      name: 'contacts.counterpartyAgent.x.cellPhone',
      type: 'phone',
    },
    {
      name: 'contacts.counterpartyAgent.x.brokerage.companyName',
      type: 'default',
    },
    {
      name: 'contacts.counterpartyAgent.x.brokerage.licenseNumber',
      type: 'default',
    },
  ],
  collapsedName: [
    'contacts.counterpartyAgent.x.firstName',
    'contacts.counterpartyAgent.x.lastName',
  ],
  layout: [
    [
      {
        name: 'contacts.counterpartyAgent.x.submitAs',
        size: 100,
      },
    ],
    [
      {
        name: 'contacts.counterpartyAgent.x.firstName',
        size: 50,
      },
      {
        name: 'contacts.counterpartyAgent.x.lastName',
        size: 50,
      },
    ],
    [
      {
        name: 'contacts.counterpartyAgent.x.email',
        size: 50,
      },
      {
        name: 'contacts.counterpartyAgent.x.cellPhone',
        size: 50,
      },
    ],
    [
      {
        name: 'contacts.counterpartyAgent.x.licenseNumber',
        size: 100,
      },
    ],
    [
      {
        name: 'contacts.counterpartyAgent.x.brokerage.companyName',
        size: 50,
      },
      {
        name: 'contacts.counterpartyAgent.x.brokerage.licenseNumber',
        size: 50,
      },
    ],
    [
      {
        name: 'contacts.counterpartyAgent.x.brokerage.street1',
        size: 75,
      },
      {
        name: 'contacts.counterpartyAgent.x.brokerage.street2',
        size: 25,
      },
    ],
    [
      {
        name: 'contacts.counterpartyAgent.x.brokerage.city',
        size: 50,
      },
      {
        name: 'contacts.counterpartyAgent.x.brokerage.state',
        size: 25,
        mobileSize: 50,
      },
      {
        name: 'contacts.counterpartyAgent.x.brokerage.zip',
        size: 25,
        mobileSize: 50,
      },
    ],
  ],
  fields: {
    firstName: {
      name: 'contacts.counterpartyAgent.x.firstName',
      entity: 'contacts',
      entityType: 'counterpartyAgent',
      type: 'autofill',
      label: 'First Name',
      placeholderText: '',
      disabledForIndex: -1,
      action: {
        name: 'autofill',
        provider: 'contactSuggestion',
        label: {
          primary: 'fullName',
          secondary: 'email',
        },
        props: [
          {
            from: 'googleContactId',
            to: 'contacts.counterpartyAgent.x.googleContactId',
          },
          {
            from: 'contactSource',
            to: 'contacts.counterpartyAgent.x.contactSource',
          },
          {
            from: 'firstName',
            to: 'contacts.counterpartyAgent.x.firstName',
          },
          {
            from: 'lastName',
            to: 'contacts.counterpartyAgent.x.lastName',
          },
          {
            from: 'email',
            to: 'contacts.counterpartyAgent.x.email',
          },
          {
            from: 'cellPhone',
            to: 'contacts.counterpartyAgent.x.cellPhone',
          },
          {
            from: 'licenseNumber',
            to: 'contacts.counterpartyAgent.x.licenseNumber',
          },
          {
            from: 'avatar',
            to: 'contacts.counterpartyAgent.x.avatar',
          },
          {
            from: 'brokerage.street1',
            to: 'contacts.counterpartyAgent.x.brokerage.street1',
          },
          {
            from: 'brokerage.street2',
            to: 'contacts.counterpartyAgent.x.brokerage.street2',
          },
          {
            from: 'brokerage.city',
            to: 'contacts.counterpartyAgent.x.brokerage.city',
          },
          {
            from: 'brokerage.state',
            to: 'contacts.counterpartyAgent.x.brokerage.state',
          },
          {
            from: 'brokerage.zip',
            to: 'contacts.counterpartyAgent.x.brokerage.zip',
          },
          {
            from: 'brokerage.licenseNumber',
            to: 'contacts.counterpartyAgent.x.brokerage.licenseNumber',
          },
          {
            from: 'brokerage.companyName',
            to: 'contacts.counterpartyAgent.x.brokerage.companyName',
          },
          {
            from: 'userId',
            to: 'contacts.counterpartyAgent.x.userId',
          },
        ],
      },
    },
    lastName: {
      name: 'contacts.counterpartyAgent.x.lastName',
      entity: 'contacts',
      entityType: 'counterpartyAgent',
      type: 'text',
      label: 'Last Name',
      placeholderText: '',
      disabledForIndex: -1,
    },
    email: {
      name: 'contacts.counterpartyAgent.x.email',
      entity: 'contacts',
      entityType: 'counterpartyAgent',
      type: 'text',
      label: 'Email',
      placeholderText: '',
      disabledForIndex: -1,
      validation: [
        {
          type: 'email',
          message: 'Invalid Email',
        },
      ],
    },
    cellPhone: {
      name: 'contacts.counterpartyAgent.x.cellPhone',
      entity: 'contacts',
      entityType: 'counterpartyAgent',
      type: 'phone',
      label: 'Cell Phone',
      placeholderText: '',
      disabledForIndex: -1,
      validation: [
        {
          type: 'phone',
          message: 'Invalid phone number',
        },
      ],
    },
    licenseNumber: {
      name: 'contacts.counterpartyAgent.x.licenseNumber',
      entity: 'contacts',
      entityType: 'counterpartyAgent',
      type: 'text',
      label: 'Agent License Number',
      placeholderText: '',
      disabledForIndex: -1,
      validation: [licenseNumberCharacterValidation],
    },
    brokerageCompanyName: {
      name: 'contacts.counterpartyAgent.x.brokerage.companyName',
      entity: 'contacts',
      entityType: 'counterpartyAgent',
      type: 'text',
      label: 'Brokerage Name',
      placeholderText: '',
      disabledForIndex: -1,
    },
    brokerageLicenseNumber: {
      name: 'contacts.counterpartyAgent.x.brokerage.licenseNumber',
      entity: 'contacts',
      entityType: 'counterpartyAgent',
      type: 'text',
      label: 'Brokerage License Number',
      placeholderText: '',
      disabledForIndex: -1,
      validation: [licenseNumberCharacterValidation],
    },
    brokerageStreet1: {
      name: 'contacts.counterpartyAgent.x.brokerage.street1',
      entity: 'contacts',
      entityType: 'counterpartyAgent',
      type: 'autofill',
      label: 'Street',
      placeholderText: '',
      disabledForIndex: -1,
      action: {
        name: 'autofill',
        provider: 'googlePlacesSearch',
        label: {
          primary: 'label.primary',
          secondary: 'label.secondary',
        },
        props: [
          {
            from: 'street1',
            to: 'contacts.counterpartyAgent.x.brokerage.street1',
          },
          {
            from: 'street2',
            to: 'contacts.counterpartyAgent.x.brokerage.street2',
          },
          {
            from: 'city',
            to: 'contacts.counterpartyAgent.x.brokerage.city',
          },
          {
            from: 'state',
            to: 'contacts.counterpartyAgent.x.brokerage.state',
          },
          {
            from: 'county',
            to: 'contacts.counterpartyAgent.x.brokerage.county',
          },
          {
            from: 'zip',
            to: 'contacts.counterpartyAgent.x.brokerage.zip',
          },
        ],
      },
    },
    brokerageStreet2: {
      name: 'contacts.counterpartyAgent.x.brokerage.street2',
      entity: 'contacts',
      entityType: 'counterpartyAgent',
      type: 'text',
      label: 'Apt/Unit/Suite Number',
      placeholderText: '',
      disabledForIndex: -1,
    },
    brokerageCity: {
      name: 'contacts.counterpartyAgent.x.brokerage.city',
      entity: 'contacts',
      entityType: 'counterpartyAgent',
      type: 'text',
      label: 'City',
      placeholderText: '',
      disabledForIndex: -1,
    },
    brokerageState: {
      name: 'contacts.counterpartyAgent.x.brokerage.state',
      entity: 'contacts',
      entityType: 'counterpartyAgent',
      type: 'state',
      label: 'State',
      placeholderText: '',
      disabledForIndex: -1,
    },
    brokerageZip: {
      name: 'contacts.counterpartyAgent.x.brokerage.zip',
      entity: 'contacts',
      entityType: 'counterpartyAgent',
      type: 'zip',
      label: 'Zip Code',
      placeholderText: '',
      disabledForIndex: -1,
    },
    userId: {
      name: 'contacts.counterpartyAgent.x.userId',
      label: 'User Id',
      entity: 'contacts',
      entityType: 'counterpartyAgent',
      type: 'hidden',
    },
  },
} satisfies CoverSheetConfigCard;
